import { render, staticRenderFns } from "./list-dije.vue?vue&type=template&id=4be2df31"
import script from "./list-dije.vue?vue&type=script&lang=js"
export * from "./list-dije.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports